import React, { useState } from 'react'
import MultiSelectCreatable from './MultiSelect';
import { gaEvent } from '../utils/GoogleAnalytics/gatracking';

const VideoMeet = ({glid, ak}) => {
    const [showVideoMeetTooltip, setShowVideoMeetTooltip] = useState(false);
    
    const handleVideoMeetVisibility = () => {
        setShowVideoMeetTooltip(!showVideoMeetTooltip);
        gaEvent("VideoMeet_btn", "VideoMeet_btn", "Click", 'VideoMeet', glid);
    }

    return (
        <>
            <span
                className="bi bi-camera-video cp ml10"
                onClick={() => {
                    handleVideoMeetVisibility();
                }}
            ></span>
            {showVideoMeetTooltip && (
                <div className="videomeettooltip">
                    <div className="videomeettooltiptext">
                        <div className="" style={{ margin: "0px" }}>
                            <MultiSelectCreatable
                                glid={glid}
                                ak={ak}
                                setShowVideoMeetTooltip={handleVideoMeetVisibility}
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default VideoMeet;